<mat-form-field appearance="outline" style="width: 150px;">
  <mat-label>{{ label }}</mat-label>
  <input matInput type="number" min="0" [max]="maxPercent" [disabled]="disabled" [ngModel]="round2(percent)" (ngModelChange)="onPercentChange($event)" enterNavigation>
  @if (percent != null && absolute) {
    <span matTextSuffix style="display:inline-block; width: 70px;">% ({{ absolute | number:'1.0-2':'da' }} {{ suffix }})</span>
  }
</mat-form-field>
